import { getCrossAppCache, setCrossAppCache } from '@/utils/cross-app-cache';
import type { SampleAccountsApi, WorkspaceObjectType } from '.';
import { servicesApi } from '@/services/api/deprecated';

export const sampleAccounts = async () => {
  const url = '/sample_accounts';
  const cachedSampleAccounts = getCrossAppCache(url);
  if (cachedSampleAccounts != null) {
    return cachedSampleAccounts;
  }
  const { data } = await servicesApi.get<SampleAccountsApi>(url);
  setCrossAppCache({ key: url, value: data });
  return data;
};

export const listWorkspaceObjectTypes = async (accountId: number, workspaceId: number) => {
  const { data } = await servicesApi.get<{ object_types: WorkspaceObjectType[] }>(
    `/environments/${workspaceId}/object_types`,
  );
  return data.object_types;
};
